import { user } from '../../utils';
import { CommentCreatedEvent } from '../../Shared/events';
import { CommentCreatedBIModel } from '../models';
import { track } from '../../tracking/bi-track';

export const commentCreatedBIEventListener = () => {
    document.addEventListener(CommentCreatedEvent.eventType, (commentCreatedEvent) => {
        const commentCreatedBIModel = CommentCreatedBIModel.createFromDomainEvent(user.id, commentCreatedEvent);
        track(commentCreatedBIModel);
    });
};
